window.bugsanddrugs = window.bugsanddrugs || {};

bugsanddrugs.form_original = {}
bugsanddrugs.updatedDirty = false

$(document).on('ajax:beforeSend', 'a.dirtycheck[data-remote=true]', function (event, xhr, status, error) {
  // alert('checking before send');
  return bugsanddrugs.checkDirty()
});

bugsanddrugs.updateDirtyForm = function (force) {
  if (!bugsanddrugs.updatedDirty) {

    let edit_form = $('form.edit_page')[0]
    if (!edit_form || !edit_form.elements) {
      return
    }
    // let edit_form = ( document.forms && document.forms[0] ) ? document.forms[0] : {}
    for (let i in edit_form.elements) {
      let r = edit_form.elements[i]
      if (r.type == 'text' || r.type == 'number' || r.id == 'page_html_page_type' || r.id == 'page_search_entries') {
        bugsanddrugs.form_original[r.id] = (r.value || r.selectedIndex)
      }
    }
    // console.log(bugsanddrugs.form_original)
    bugsanddrugs.updatedDirty = true
  }
  // console.log('dirty update', force)
}

bugsanddrugs.isPageDirty = function () {
  if (!bugsanddrugs.updatedDirty) {
    bugsanddrugs.updateDirtyForm()
  }
  if (tinymce && tinymce.activeEditor.isDirty()) {
    // console.log('tiny is dirty')
    return true
  }
  let check_edit_form = $('form.edit_page')[0]
  for (let i in check_edit_form.elements) {
    let r = check_edit_form.elements[i]
    if (r.type == 'text' || r.type == 'number' || r.id == 'page_html_page_type' || r.id == 'page_search_entries') {
      if (bugsanddrugs.form_original[r.id] != (r.value || r.selectedIndex)) {
        // console.log('dirty form found')
        // console.log('dirty form found', bugsanddrugs.form_original[r.id], (r.value || r.selectedIndex))
        return true
      }
    }
  }
  return false
}

bugsanddrugs.checkDirty = function (e) {
  // alert('checking dirty')

  if (bugsanddrugs.isPageDirty()) {
    let r = confirm(
      "Leave page without Saving? To save changes, click cancel then save."
    );
    if (r) {
      bugsanddrugs.updatedDirty = false
    }
    return r
  } else {
    bugsanddrugs.updatedDirty = false
    return true
  }
}

// intial set of form after load
setTimeout(function () {
  bugsanddrugs.updateDirtyForm(), 250
})